import { defineStore } from 'pinia'
import { encryptedStorage } from '@/utils/encryption'
import { initialState, persistedState } from './state'
import { actions } from './actions'
import { getters } from './getters'
import { CACHE_KEYS, TTL_VALUES } from './constants'

/**
 * İçerik yönetimi için Pinia store
 */
export const useContentStore = defineStore('content', {
  /**
   * State'i döndürür
   * @returns {Object} state
   */
  state: () => ({ ...initialState }),
  
  /**
   * Store actions
   */
  actions,
  
  /**
   * Store getters
   */
  getters,
  
  /**
   * Persist ayarları
   */
  persist: {
    key: 'content-store',
    storage: encryptedStorage,
    paths: persistedState,
  },
})

// Dışa aktarımlar
export {
  CACHE_KEYS,
  TTL_VALUES
}
